module.exports = __webpack_public_path__ + "static/media/ico-cash.73d7aff5.svg";